import { Link } from 'react-router-dom';
import { Plus, Sparkles, UserPlus, History, Mail } from 'lucide-react';

interface FreeUserSidebarContentProps {
  onNewSession: () => void;
  hideSignupCTA?: boolean;
}

export function FreeUserSidebarContent({
  onNewSession,
  hideSignupCTA = false,
}: FreeUserSidebarContentProps) {
  return (
    <>
      {/* New Session Button */}
      <div className="p-3">
        <button
          onClick={onNewSession}
          className="w-full flex items-center gap-3 px-4 py-3 rounded-xl bg-surface-light/20 hover:bg-surface-light/40 border border-border text-text-primary transition-colors"
        >
          <Plus className="w-5 h-5 flex-shrink-0 text-primary" />
          <span className="text-[13px] font-medium">New Research</span>
        </button>
      </div>

      {/* Free User CTA Section */}
      <div className="flex-1 flex flex-col px-3">
        {/* Upgrade CTA Card */}
        {!hideSignupCTA && (
          <div className="bg-surface-light/20 border border-border rounded-xl p-4 mb-4">
            <div className="flex items-center gap-2 mb-2">
              <Sparkles className="w-4 h-4 text-primary" />
              <span className="text-sm font-medium text-text-primary">Get Started Free</span>
            </div>
            <p className="text-xs text-text-secondary mb-3">
              Create an account to unlock all research tools. Top up credits anytime or subscribe for more.
            </p>
            <Link
              to="/signup"
              className="flex items-center justify-center gap-2 w-full px-4 py-2.5 bg-primary text-black font-medium rounded-lg hover:bg-primary-hover transition-colors text-sm"
            >
              <UserPlus className="w-4 h-4" />
              Create Free Account
            </Link>
          </div>
        )}

        {/* Feature list */}
        <div className="space-y-3 text-sm">
          <div className="flex items-start gap-3 text-text-muted">
            <History className="w-4 h-4 flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-text-secondary text-[13px] font-medium">Research History</p>
              <p className="text-xs text-text-muted">Access your past research sessions</p>
            </div>
          </div>
          <div className="flex items-start gap-3 text-text-muted">
            <Mail className="w-4 h-4 flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-text-secondary text-[13px] font-medium">Daily Newsletter</p>
              <p className="text-xs text-text-muted">Get personalized research delivered daily</p>
            </div>
          </div>
        </div>

      </div>
    </>
  );
}
